import React from 'react'

import { Flex, Text } from 'components/ds'
import LoadingIndicator from 'components/ui/loading-indicator'

export const RightsLoading = () => {
  return (
    <Flex justify="start" align="center" gap="3" my="2">
      <LoadingIndicator />
      <Text size="3" weight="medium">
        Fetching Rights Data
      </Text>
    </Flex>
  )
}
